export const MAIL_TYPES = {
	MAIL_CATEGORY: 'Mail Category',
	PROMOTION: 'Promotion',
};

export const mailTypeOptions = Object.entries(MAIL_TYPES).map(
	([value, label]) => ({
		value,
		label,
	}),
);
